import { Card, CardContent, CardHeader, FormControlLabel, FormLabel, Grid, Grid2, InputAdornment, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { APP_HOST, FORM_TYPE, JENJANG_PENDIDIKAN } from "../../helper/Constant";
import { useEffect, useState } from "react";
import GridForm from "../general/GridForm";
import dayjs from "dayjs";

function DataAyah({ handleChange, data, isPenanggungJawab = false }) {
    useEffect(() => {
        if (!data) {
            handleChange("status", "Hidup");
        }
    }, []);

    return (
        <>
            <Card>
                <CardHeader title="Data Ayah" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ padding: '10px' }} container spacing={2}>
                        <GridForm column={4} titleForm={"Nama Ayah"} attribute={{ name: "nama_ayah", value: data?.nama_ayah }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Pekerjaan"} attribute={{ name: "pekerjaan", value: data?.pekerjaan }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Nomor Handphone"} attribute={{
                            type: "number",
                            name: "no_hp",
                            value: data?.no_hp
                        }} isRequired={isPenanggungJawab} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Tempat Lahir"} attribute={{ name: "tempat_lahir", value: data?.tempat_lahir }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Penghasilan Per Bulan"} attribute={{ name: "penghasilan", value: data?.penghasilan }} isRequired={false} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Email"} attribute={{ name: "email", value: data?.email }} isRequired={isPenanggungJawab} handleChange={handleChange}></GridForm>
                        <GridForm type={FORM_TYPE.DATEPICKER} column={4} titleForm={"Tanggal Lahir"} attribute={{ name: "tanggal_lahir", value: (data?.tanggal_lahir) ? dayjs(data.tanggal_lahir) : null, format: "DD/MM/YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Pendidikan Terakhir</FormLabel>
                            <Select required name="pendidikan" value={data?.pendidikan} onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(JENJANG_PENDIDIKAN).map(([key, value]) => {
                                        return (
                                            <MenuItem value={value} key={key}>{value}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={4} xl={4} lg={4}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Status Ayah</FormLabel>
                            <RadioGroup data-radioname="status" data-required="true" name="status" value={data?.status} onChange={(e) => { handleChange(e.target.name, e.target.value) }} defaultValue={"Hidup"} row>
                                <FormControlLabel value={"Hidup"} control={<Radio></Radio>} label="Hidup"></FormControlLabel>
                                <FormControlLabel value={"Meninggal"} control={<Radio></Radio>} label="Meninggal"></FormControlLabel>
                            </RadioGroup>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={0} sm={0} md={4} xl={4} lg={4}>
                        </Grid>
                        <GridForm column={4} titleForm={"Jurusan Pendidikan (Optional)"} attribute={{ name: "jurusan_pendidikan", value: data?.jurusan_pendidikan }} isRequired={false} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Nomor Induk Kependudukan (NIK)"} attribute={{ name: "nik", value: data?.nik, type: 'number' }} isRequired={true} handleChange={handleChange}></GridForm>
                    </Grid>
                </CardContent>
            </Card>

        </>
    );
}

export default DataAyah;